export const DEFAULT_PAGE_KEY = "dashboard";

export const PAGE_KEYS = [
    "dashboard",
    "statistics",
    "invoices",
    // Collective payments (FEAT-149); only reachable with the payment-collection flag,
    // MainAppIndex falls back to the dashboard otherwise.
    "paymentCollections",
    "mandates",
    "contacts",
    "invoiceErpPage",
    "gocardlessPayouts",
    "emailSettings",
    "dunning",
    "users",
    "settings",
    "account",
    "pricingTable",
];

export const PAGE_KEY_SET = new Set(PAGE_KEYS);

export const resolvePageKey = (value) => {
    if (typeof value !== "string") {
        return DEFAULT_PAGE_KEY;
    }

    if (PAGE_KEY_SET.has(value)) {
        return value;
    }

    return DEFAULT_PAGE_KEY;
};

export const buildAppPageUrl = (pageKey) => {
    const resolved = resolvePageKey(pageKey);

    if (resolved === DEFAULT_PAGE_KEY) {
        return "/app";
    }

    return `/app?page=${encodeURIComponent(resolved)}`;
};

// Company settings ("?page=settings") are split into tabs, addressable via
// "?page=settings&tab=<key>" so support answers and emails can deep-link.
export const SETTINGS_TAB_KEYS = ["integrations", "collection", "communication", "api"];

export const DEFAULT_SETTINGS_TAB = "integrations";

// Collective-payment settings (collection tab, scrolled to its card).
export const PAYMENT_COLLECTION_SETTINGS_URL = "/app?page=settings&tab=collection#payment-collection";

const SETTINGS_TAB_KEY_SET = new Set(SETTINGS_TAB_KEYS);

// Anchors of the old single settings page, so old deep links still land on the
// right block ("?page=settings#payment-condition").
const LEGACY_SETTINGS_HASHES = {
    "#erp-connections": "integrations",
    "#payment-condition": "collection",
};

/**
 * Tab to show for a settings URL: a known `tab` wins, then a legacy anchor,
 * otherwise the default tab.
 */
export const resolveSettingsTab = (value, hash) => {
    if (typeof value === "string" && SETTINGS_TAB_KEY_SET.has(value)) {
        return value;
    }

    if (typeof hash === "string" && LEGACY_SETTINGS_HASHES[hash]) {
        return LEGACY_SETTINGS_HASHES[hash];
    }

    return DEFAULT_SETTINGS_TAB;
};

export const buildSettingsTabUrl = (tab) => (
    `/app?page=settings&tab=${encodeURIComponent(resolveSettingsTab(tab))}`
);

// Personal page ("My profile & security"), opened from the header user menu.
export const PROFILE_PATH = "/app/profile";

// Pseudo page key MainAppIndex uses while PROFILE_PATH is open (not a "?page=" value).
export const PROFILE_PAGE_KEY = "profile";
